import React, { FC } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

interface IProps {
    meter:any
};

function round(num:any) {
    if(!num){
      return num
    }
    return Math.round((num + Number.EPSILON) * 100)/100;
}


const CostAvoidanceMeterTable:FC<IProps> = (props) => {
    let columns:any = []    
    if (props.meter.type === "Electric"){
      columns = [
        {
          id:'date',
          accessorKey:'date',
          header: "Month/Year",
          cell: (props: any) => {
            return (
              <div className="center-all">{props.getValue()}</div>
            );
          },
          size: 150,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
            id:'kwh_current_cost',
            accessorKey: 'kwh_current_cost',
            header: `Current KWH Cost`,
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_adjusted_cost',
            accessorKey: 'kwh_adjusted_cost',
            header: "Adjusted KWH Cost",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_current',
            accessorKey: 'kwh_current',
            header: "Current KWH",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_adjusted',
            accessorKey: 'kwh_adjusted',
            header: "Adjusted KWH",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kwh_current_rate',
            accessorKey: 'kwh_current_rate',
            header: "Current KWH Rate",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_current_cost',
            accessorKey: 'kw_current_cost',
            header: "Current KW Cost",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_adjusted_cost',
            accessorKey: 'kw_adjusted_cost',
            header: "Adjusted KW Cost",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_current',
            accessorKey: 'kw_current',
            header: "Current KW",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_adjusted',
            accessorKey: 'kw_adjusted',
            header: "Adjusted KW",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'kw_current_rate',
            accessorKey: 'kw_current_rate',
            header: "Current KW Rate",
            cell: (props: any) => {
                return (
                <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'current_num_days',
            accessorKey: 'current_num_days',
            header: "Current Number of Days",
            cell: (props: any) => {
                return (
                <div className="center-all">{props.getValue()}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'current_cdd',
            accessorKey: 'current_cdd',
            header: "Current CDD",
            cell: (props: any) => {
                return (
                <div className="center-all">{props.getValue()}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        },
        {
            id:'current_hdd',
            accessorKey: 'current_hdd',
            header: "Current HDD",
            cell: (props: any) => {
                return (
                <div className="center-all">{props.getValue()}</div>
                );
            },
            size: 150,
            enableColumnFilter: false,
            enableGlobalFilter: false,
        }
      ]
    }

    // NATURAL GAS METER COLUMNS
    else if (props.meter.type === "Natural Gas"){
    columns = [
    {
      id:'date',
      accessorKey:'date',
      header: "Month/Year",
      cell: (props: any) => {
        return (
          <div className="center-all">{props.getValue()}</div>
        );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_current_cost',
      accessorKey: 'therms_current_cost',
      header: "Current Therms Cost",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_adjusted_cost',
      accessorKey: 'therms_adjusted_cost',
      header: "Adjusted Therms Cost",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_current',
      accessorKey: 'therms_current',
      header: "Current Therms",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_adjusted',
      accessorKey: 'therms_adjusted',
      header: "Adjusted Therms",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'therms_current_rate',
      accessorKey: 'therms_current_rate',
      header: "Current Therms Rate",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_num_days',
      accessorKey: 'current_num_days',
      header: "Current Number of Days",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_cdd',
      accessorKey: 'current_cdd',
      header: "Current CDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_hdd',
      accessorKey: 'current_hdd',
      header: "Current HDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    ]
    }
    // All Other Meters (Chilled Water, Steam, etc.) - Default Columns
    else {
    columns = [
    {
      id:'date',
      accessorKey:'date',
      header: "Month/Year",
      cell: (props: any) => {
        return (
          <div className="center-all">{props.getValue()}</div>
        );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'energy_current_cost',
      accessorKey: 'energy_current_cost',
      header: "Current Cost",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'energy_adjusted_cost',
      accessorKey: 'energy_adjusted_cost',
      header: "Adjusted Cost",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'energy_current',
      accessorKey: 'energy_current',
      header: "Current Use",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'energy_adjusted',
      accessorKey: 'energy_adjusted',
      header: "Adjusted Use",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'energy_current_rate',
      accessorKey: 'energy_current_rate',
      header: "Current Rate",
      cell: (props: any) => {
          return (
          <div className="center-all">{round(props.getValue())?.toLocaleString("en")}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_num_days',
      accessorKey: 'current_num_days',
      header: "Current Number of Days",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_cdd',
      accessorKey: 'current_cdd',
      header: "Current CDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
      id:'current_hdd',
      accessorKey: 'current_hdd',
      header: "Current HDD",
      cell: (props: any) => {
          return (
          <div className="center-all">{props.getValue()}</div>
          );
      },
      size: 150,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    ]
    }
    

    const table = useReactTable({
        data: props.meter.adjusted_nd_current,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
      });

    return <div style={{width:'100%',marginTop:'0.5rem', display:'flex', justifyContent:'center',textAlign:'center'}}>
    <div className="data-table" style={{ width: table.getTotalSize(), marginBottom: "2em", overflowX: "auto",maxHeight:'550px'}}>
        {table.getHeaderGroups().map((headerGroup: any) => (
          <div key={headerGroup.id} className="tr">
            {headerGroup.headers.map((header: any) => {
              return (
                <div
                  key={header.id}
                  className="th"
                  style={{ width: header.getSize() }}

                >
                  {header.column.columnDef.header}
                </div>
              );
            })}
          </div>
        ))}

        {table.getRowModel().rows.map((row: any) => (
          <div
            key={row.id}
            className="tr"
            style={{ width: table.getTotalSize() }}
          >
            {row.getVisibleCells().map((cell: any) => {
              return (
                <div
                  key={cell.id}
                  className="td"
                  style={{ width: cell.column.getSize() }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              );
            })}
          </div>
        ))}
        
    </div>
    </div>
};

export default CostAvoidanceMeterTable;


